export const getImageUrl = (shortPath) => {
    const baseURL = process.env.VUE_APP_IMG_URL;
    return `${baseURL}${shortPath}`
}